import EmployeeCard from './EmployeeCard';
import ConnectedEmployeeCard from './Connect';

export default ConnectedEmployeeCard;

export { EmployeeCard };
